export const iconFontAwesomeUsersPeoplePoo = (
	<i className="fa-solid fa-poo"></i>
);
